import React, { useCallback, FC } from 'react';
import { GridRenderEditCellParams } from '@mui/x-data-grid/models/params/gridCellParams';
import { TableNumericField } from '../../../../../../../../shared/components/table/styles/styleFields.ts';
import { articleOverviewState } from '../../articlesOverview.state.tsx';
import { snackbarService } from '../../../../../../../../shared/components/snackbar/service/snackbar.service.ts';
import { t } from 'i18next';
import { isEnterKey } from '../../../../../../../../shared/helpers/utils/utils.helper.ts';

export const QuantityEditCell: FC<GridRenderEditCellParams> = ({
  api,
  type,
  orderType,
  ...params
}) => {
  const { setEditCellValue, updateRows, getSortedRows, stopCellEditMode } = api;
  const { value, field, id, formattedValue, row } = params;

  const updateCell = useCallback(
    (v: number | null) => {
      const filteredRows = getSortedRows().filter(
        (el) => el.orderId === row.orderId && el.id !== id,
      );
      const everyQuantityNotZero = filteredRows.every((el) => el.quantity !== 0);
      if ((v || 0) !== 0 || (filteredRows.length !== 0 && everyQuantityNotZero)) {
        setEditCellValue({ id, field, value: v });
        if (Number(formattedValue) !== v) {
          updateRows([
            {
              ...params.row,
              [field]: v,
              error: false,
              manualChanged: params.row?.primaryQuantity !== v,
              ...(params.row?.primaryQuantity === undefined && {
                primaryQuantity: Number(formattedValue),
              }),
            },
          ]);
          articleOverviewState.pub.updateSaveStatus();
        }
      } else {
        snackbarService.pub.show({
          type: 'warning',
          content: t('order.not_zero_message'),
        });
      }
    },
    [params],
  );

  const handleKeyDown = (v: React.KeyboardEvent) => {
    if (v.target instanceof HTMLInputElement && isEnterKey(v)) {
      const value = v.target.value.replace(/,/g, '.');
      updateCell(value ? Number(value) : null);
      stopCellEditMode({ id, field });
    }
  };

  return (
    <TableNumericField
      slotProps={{ htmlInput: { autoComplete: 'off' } }}
      onBlur={updateCell}
      min={-10000000}
      onKeyDown={handleKeyDown}
      autoFocus
      precision={3}
      noTrailingZeros
      value={value}
      keyChange={false}
    />
  );
};
